import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import Root from "./Root.vue";
import router from "./router";
import store from "./store";
import Amplify, {
  Auth,
  Storage
} from "aws-amplify";
import "./registerServiceWorker";
import * as VueGoogleMaps from "vue2-google-maps";
import AMPLIFY_CONFIG from "./amplify.config.js";
import "./main.scss";
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);
import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);
Vue.config.devtools = true;
Amplify.configure(AMPLIFY_CONFIG);

const SET_INSTALL_PROMPT = "SET_INSTALL_PROMPT";
window.addEventListener("beforeinstallprompt", e => {
  e.preventDefault();
  let deferred = e;
  store.commit(SET_INSTALL_PROMPT, deferred);
});

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "AIzaSyBgk-dUf1iH19bghDBZ7n3LxQ4QmK9FJ_E",
    libraries: "places",
    v: "3.52" // Specify a stable version
  },
  installComponents: true
});

// Ensure Google Maps components are properly registered with kebab-case names
Vue.component('gmap-map', VueGoogleMaps.Map);
Vue.component('gmap-marker', VueGoogleMaps.Marker);
Vue.component('gmap-info-window', VueGoogleMaps.InfoWindow);
Vue.component('gmap-polyline', VueGoogleMaps.Polyline);
Vue.component('gmap-polygon', VueGoogleMaps.Polygon);
Vue.component('gmap-circle', VueGoogleMaps.Circle);
Vue.component('gmap-rectangle', VueGoogleMaps.Rectangle);
Vue.component('gmap-autocomplete', VueGoogleMaps.Autocomplete);
Vue.component('gmap-place-input', VueGoogleMaps.PlaceInput);
Vue.component('gmap-street-view-panorama', VueGoogleMaps.StreetViewPanorama);

var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return isMobile.Android() || isMobile.iOS() || isMobile.Windows();
  }
};

function getBrowserId() {
  var aKeys = ["MSIE", "Edge", "Firefox", "Safari", "Chrome", "Opera"],
    sUsrAg = navigator.userAgent,
    nIdx = aKeys.length - 1;
  for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);
  return aKeys[nIdx].toLowerCase();
}

function checkBrowserToMobileType(browser, type) {
  if (browser === "chrome" && type === "android") {
    return true;
  }
  if (browser === "safari" && (type === "iphone" || type === "ipad")) {
    return true;
  }
  if ((browser === "Edge" || browser === "MSIE") && type === "iemobile") {
    return true;
  }
}
var mobileType = isMobile.any();
mobileType = mobileType ? mobileType[0].toLowerCase() : null;
var ios = isMobile.iOS();
var browserType = getBrowserId();

var deviceMatchBrowser = checkBrowserToMobileType(browserType, mobileType);

const suggestBrowsers = {
  android: "Google Chrome",
  iphone: "Safari",
  ipad: "Safari",
  iemobile: "Microsoft Edge or Internet Explorer"
};

store.dispatch("deviceMatchBrowser", deviceMatchBrowser);
store.dispatch("setNetworkListener");
store.dispatch("setBrowserType", browserType);
store.dispatch("setIphone", ios ? true : false);
store.dispatch("setMobileType", mobileType);
store.dispatch("setSuggestedBrowser", suggestBrowsers[mobileType]);
store.dispatch("checkForServiceWorker");
store.dispatch("setInitialIntro");
store.dispatch("setInitialOnboarding");
store.dispatch("initialSetLocalUser");
store.dispatch("setInitialDemoRequest");
store.dispatch("setInitialSetupAndPreloading");

new Vue({
  router,
  store,
  render: h => h(Root)
}).$mount("#app");